<template>
  <div style="background-color: #172534; height:100vh; ">
    <router-view ></router-view>
  </div>
</template>

<script>


export default {
  name: 'App',
  components: {
  },
  data () {
    return {
    }
  }
}
</script>
